/* eslint-disable no-console */

import { configuracion } from "src/configuracion";

/**
 * Prints a debug message with the specified level and caller information.
 * @param text The debug message to print.
 * @param caller The name of the function or context calling this debug print.
 * @param level The debug level: 'info', 'warning', 'error', or 'neutral'. Defaults to 'info'.
 */
export const printDebug = (
  text: string,
  caller: string = 'unknown',
  level: "info" | "warning" | "error" = "info",
): void => {
  
  if (configuracion.production) {
    return;
  }
  
  const log = `[DEBUG] (${caller}) ${text}`;

  switch (level) {
    case "error":
      console.error(log);
      break;
    case "info":
      console.info(log);
      break;
    case "warning":
      console.warn(log);
    default:
      console.log(log);
      break;
  }
};
